import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { company, services } from '../data/content';
import { privacyPolicy, termsOfService } from '../data/legal';
import { LegalModal } from './LegalModal';
import { PhoneIcon, MailIcon, GoogleIcon, FacebookIcon, TikTokIcon } from './icons';
type LegalDoc = 'privacy' | 'terms';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  return <footer className="w-full border-t border-navy-700 bg-navy-900 py-12" data-id="element-237" data-mp="3uftmhouw9w0v">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-238" data-mp="37o2ul235f8m">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-239" data-mp="3lem1u9lawtp9">
          <div className="lg:col-span-2" data-id="element-240" data-mp="3lggbusv1b1ek">
            <div className="flex items-center gap-3" data-id="element-241" data-mp="3qcxa4fvy6w5d">
              <img src={company.logo} alt="" className="h-12 w-12 object-contain" data-id="element-242" data-mp="3qfjighqnxfon" />
              <span className="font-display text-lg font-bold tracking-tight text-white" data-id="element-243" data-mp="29xm0kogz74j3">
                {company.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-navy-200" data-id="element-244" data-mp="3l90nfv0aswyq">
              20 years of family-owned excellence in pool plaster, tile, coping, spray deck
              repair, and complete backyard remodels.
            </p>
            <p className="mt-4 text-sm font-semibold text-sky-300" data-id="element-245" data-mp="3v9axx7uy7qa7">
              Licensed · Insured · Honest · Trusted
            </p>
            <div className="mt-5 flex flex-wrap gap-3" data-id="element-246" data-mp="830hxf7jlyyw">
              <a href={company.googleProfileUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-247" data-mp="81fnrqp54i1k">
                <GoogleIcon className="h-4 w-4" data-id="element-248" data-mp="cu8u2j09byfr" />
                5.0 stars on Google
              </a>
              <a href={company.facebookUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-249" data-mp="qu1ejwl6xifa">
                <FacebookIcon className="h-4 w-4" data-id="element-250" data-mp="yuz9nsi2n5jq" />
                Follow us on Facebook
              </a>
              <a href={company.tiktokUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 rounded-md border border-navy-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-sky-300 hover:text-sky-200" data-id="element-251" data-mp="13rpu0s0wsnay">
                <TikTokIcon className="h-4 w-4" data-id="element-252" data-mp="1hje0ofse2jkj" />
                Watch us on TikTok
              </a>
            </div>
          </div>

          

          <div data-id="element-253" data-mp="1riv4ssrzspee">
            <h2 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-254" data-mp="1rjeq8jgupvx6">
              Contact
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-255" data-mp="3ocpxniknc1y8">
              <li data-id="element-256" data-mp="3ta86za2ksj6r">
                <a href={company.phoneHref} className="flex items-center gap-2.5 text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-257" data-mp="3t9q7m4km9oum">
                  <PhoneIcon className="h-4 w-4 text-sky-300" data-id="element-258" data-mp="2agyg1b5rp7qv" />
                  {company.phoneDisplay}
                </a>
              </li>
              <li data-id="element-259" data-mp="21m0exgsguoog">
                <a href={company.emailHref} className="flex items-center gap-2.5 break-all text-sm text-navy-100 transition-colors duration-150 ease-out hover:text-sky-300" data-id="element-260" data-mp="21nla98mlubnd">
                  <MailIcon className="h-4 w-4 shrink-0 text-sky-300" data-id="element-261" data-mp="2te9eitjkrx59" />
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-navy-700 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-262" data-mp="2kcry1a299tg1">
          <p className="text-xs text-navy-300" data-id="element-263" data-mp="2fdf2m0xbje1u">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-264" data-mp="18vrypuhhqeci">
            <button type="button" onClick={() => setOpenDoc('privacy')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-265" data-mp="13xgq1n2xm9vv">
              Privacy Policy
            </button>
            <span className="h-3 w-px bg-navy-700" aria-hidden="true" data-id="element-266" data-mp="2nv7cki26twwd" />
            <button type="button" onClick={() => setOpenDoc('terms')} className="text-xs font-semibold text-navy-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-sky-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-267" data-mp="3bk00br8noyfw">
              Terms of Service
            </button>
          </nav>
        </div>
      </div>

      <AnimatePresence data-id="element-268" data-mp="1q5uezhu4wij0">
        {openDoc && <LegalModal document={openDoc === 'privacy' ? privacyPolicy : termsOfService} onClose={() => setOpenDoc(null)} data-id="element-269" data-mp="1q4sw4r6vmrqq" />}
      </AnimatePresence>
    </footer>;
}